<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="editorial-header" :class="{'theme-black': isDarkTheme}">
      <Heading
        class="title"
        :class="alignmentClass"
        :tag-field="headingSizeField"
        :text-field="titleField"
        default-tag="h1"
        :desktop-size="sizeDesktop"
        :mobile-size="sizeMobile"
      />
      <editorial-cta
        :fields="fields"
        :alignment="positionField"
      />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import mapFields from '~/helpers/map-fields'
import { decreaseTagValue } from '~/helpers/decrease-tag-value'
import ScRender from '../sc-render'
import EditorialCta from '../editorial-cta'
import Heading from '../heading'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')
const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialHeader',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRender,
    ScText: Text,
    EditorialCta,
    Heading
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    ...mapFields({
      headingSizeValue: 'headingSize.value',
      headingSizeField: 'headingSize',
      titleField: 'title',
      positionField: 'position.value'
    }),
    sizeDesktop () {
      return `size-${this.headingSizeValue[1]}`
    },
    sizeMobile () {
      return `size-${decreaseTagValue(this.headingSizeField).value[1]}`
    },
    alignmentClass () {
      return `align-${this.positionField}`.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
  .editorial-header {
    padding: 0 $space-050;
    margin-bottom: $space-090;

    &:first-child {
      margin-top: $space-090;
    }

    @include tablet() {
      padding: 0 $space-060;
      margin-bottom: $space-100;
    }

    .title {
      text-align: center;
    }

    .align-left {
      text-align: left;
    }
  }

  .theme-black {
    .title {
      color: $color-white;
    }
  }
</style>
